/**
 * Classify a material's stock level for UI color grading.
 *
 * Rules:
 *   - green:  stock > threshold
 *   - yellow: stock <= threshold AND stock > threshold / 2
 *   - red:    stock <= threshold / 2 (including 0 and negatives)
 *
 * When threshold is 0, any positive stock is green and 0/negative is red.
 *
 * @param {number} quantity - current QuantityInStock
 * @param {number} threshold - LowStockThreshold
 * @returns {'green' | 'yellow' | 'red'}
 */
const stockColor = (quantity, threshold) => {
    if (quantity <= threshold / 2) return 'red';
    if (quantity <= threshold) return 'yellow';
    return 'green';
};

export default stockColor;
